<template>
    <div>
        <div class="item_card" :class="{'n2_columns': !product.productImages, 'androidMode': isAndroidMode()}" v-for="(product, key) in cart" :key="key">

            <img v-if="product.productImages && product.productImages.small !== null " :src="getImagesURL(product, 'productImages', 'small')" class="card_column_1">
            <img v-else :src="noImage()" class="card_column_1">

            <div class="card_column_2">
                <span class="bold_text" :class="{'unavaiable': getLimits(product.productCode)}" >{{ getProductLanguage(product, 'productName') }}</span>
                <span v-if="(product.observations && product.observations.length === 0) && (product.productCombo && product.productCombo.length === 0)" class="product_desc" v-text="getProductLanguage(product, 'productDescription')"></span>

                <div class="price-section">
                   <span v-if="!hasSubgroupDiscount(product)" class="bold_text final-price">
                        {{ calculateItemPrice(product) }}
                    </span>

                    <div v-else class="price-breakdown">
                        <span class="original-price">
                            {{ getString('subtotal_dois_pontos') }} {{ formatMoney(getSubtotal(product)) }}
                        </span>
                        <span class="discount-amount">
                            {{ getString('desconto_dois_pontos') }} -{{ formatMoney(getDiscountTotal(product)) }}
                        </span>
                        <span class="final-price bold_text">
                            {{ formatMoney(product.totalItemPrice * product.quantity) }}
                        </span>
                    </div>
                </div>
            </div>

            <div class="card_column_3">
                <QuantityControl
                    :quantity="product.quantity"
                    :disabledMinus="product.insertedByEan13"
                    :disabledPlus="product.insertedByEan13"
                    @circleBtnRemove="decreaseQtty(key)"
                    @circleBtnAdd="increaseQtty(key)"
                    :disableControll="isModotap() || product.isABox || product.productScale">
                </QuantityControl>
                <div class="circle_buttons" v-if="!isModotap() && !product.isABox">
                    <CircleButton class="edit_button" :disabled="product.insertedByEan13 || product.isertedByBarCode || product.productScale" :big="iconesGrandes" :icon="edit_white" @circleBtnClick="editProduct(product, key)"></CircleButton>
                    <CircleButton :icon="delete_white" :big="iconesGrandes" @circleBtnClick="deleteProduct(key)"></CircleButton>
                </div>
            </div>

            <div class="card_column_4" v-if="(product.observations && product.observations.length > 0) || (product.productCombo && product.productCombo.length > 0)">
                <button type="button" class="details-toggle-btn" @click="toggleDetalhes(key)">
                    <span v-text="mostrar[key] ? getString('ocultar_detalhes') : getString('ver_detalhes')"></span>
                    <svg
                        class="details-toggle-btn__chevron"
                        :class="{'is-open': mostrar[key]}"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        aria-hidden="true">
                        <path fill="currentColor" d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/>
                    </svg>
                </button>
                <transition name="details-expand">
                <div class="details-panel" v-show="mostrar[key]">
                    <div class="observation-item" v-for="(observation, obsIndex) in product.observations" :key="obsIndex">
                        <div class="observation-item-image"></div>
                        <div class="observation-item-content">
                            <span class="bold_text">
                            {{ getProductLanguage(observation, 'obsName') }}
                        </span>
                        <span class="price-col" v-if="observation.price > 0">
                            {{ calculateItemComboPrice(observation, product.quantity) }}
                        </span>
                        </div>
                        <div class="detail_quantity">
                            <span v-text="calculateQuantity(observation, product.quantity)"></span>
                        </div>
                    </div>
                    <div class="combo-item" v-for="(comboItem, key2) in product.productCombo" :key="key2">
                        <img v-if="comboItem.subItemProductImages && comboItem.subItemProductImages.small !== null && ((!isFosException(comboItem, product) && !showChilds(comboItem)) && getproductscombo(comboItem,product.choosen))" :src="getImagesURL(comboItem, 'subItemProductImages', 'small')" class="img">
                        <img v-else-if="((!isFosException(comboItem, product) && !showChilds(comboItem)) && getproductscombo(comboItem,product.choosen))" :src="noImage()" class="img">
                        <div class="combo-item-content" v-if="((!isFosException(comboItem, product) && !showChilds(comboItem)) && getproductscombo(comboItem,product.choosen))">
                            <span class="bold_text" :class="{'unavaiable': getLimits(comboItem.subItemCode)}">
                                {{ getProductLanguage(comboItem, 'subItemName') }}
                            </span>
                            <span class="price-col" v-if="comboItem.price > 0">
                                {{ calculateItemComboPrice(comboItem, product.quantity) }}
                            </span>
                        </div>
                        <div class="detail_quantity" v-if="((!isFosException(comboItem, product) && !showChilds(comboItem)) && getproductscombo(comboItem,product))">
                            <span v-text="calculateQuantity(comboItem, product.quantity)"></span>
                        </div>
                        <div class="combo-item-observations" v-for="(comboItemObs, obsComboIndex) in getObservations(comboItem, product)" :key="'obscombo' + obsComboIndex">
                                <div class="combo-item-observation-content">
                                    <span class="bold_text">
                                        {{ getProductLanguage(comboItemObs, 'subItemObsName') }}
                                    </span>

                                    <span class="price-col" v-if="comboItemObs.price > 0">
                                        {{ calculateObservationPrice(comboItemObs, comboItem.quantity, product.quantity) }}
                                    </span>
                                </div>
                                <div class="detail_quantity" v-if="comboItemObs.price > 0">
                                <span v-text="calculateQuantity(comboItemObs, comboItem.quantity, product.quantity)"></span>
                            </div>
                        </div>
                        <div class="c-combo-options" v-if="getproductscombo(choosen,comboItem)" v-for="(choosen, key4) in getProductsComboCombo(comboItem.choosen)"
                            :key="key4">
                                <img v-if="choosen.subItemProductImages && choosen.subItemProductImages.small !== null" :src="getImagesURL(choosen, 'subItemProductImages', 'small')" class="img">
                                <img v-else :src="noImage()" class="img">
                                <div class="combo-item-content">
                                    <span class="bold_text" :class="{'unavaiable': getLimits(choosen.subItemCode)}">
                                        {{ getProductLanguage(choosen, 'subItemName') }}
                                    </span>
                                    <span class="price-col" v-if="choosen.price > 0">
                                        {{ calculateItemComboPrice(choosen, product.quantity) }}
                                    </span>
                                </div>
                                <div class="detail_quantity">
                                    <span v-text="calculateQuantity(choosen, product.quantity)"></span>
                                </div>
                            <div class="combo-item-observations" v-for="(choosenObs, obsComboIndex) in choosen.observations" :key="obsComboIndex">
                                <div class="combo-item-observation-content">
                                    <span class="bold_text">
                                        {{ getProductLanguage(choosenObs, 'subItemObsName') }}
                                    </span>
                                    <span class="price-col" v-if="choosenObs.price > 0">
                                        {{ calculateObservationPrice(choosenObs, choosen.quantity, product.quantity) }}
                                    </span>
                                </div>
                                <div class="detail_quantity" v-if="choosenObs.price > 0">
                                    <span v-text="calculateQuantity(choosenObs, choosen.quantity, product.quantity)"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
import CircleButton from '@/components/CircleButton'
import QuantityControl from '@/components/QuantityControl'

import Util from '@/assets/libs/util'
import CartController from '@/assets/controllers/CartController'
import LocaleController from '../assets/controllers/LocaleController'

export default {
    name: 'CheckoutItem',
    components: {
        CircleButton,
        QuantityControl
    },
    props: ['cart', 'unavailableProducts'],
    data () {
        return {
            imgPath: require('../../static/client/powered.png'),
            edit_white: require('../../static/icons/edit_white.svg'),
            delete_white: require('../../static/icons/delete_white.svg'),
            iconesGrandes: Util.getLocalConfigs('iconesGrandes'),
            mostrar: {},
            junk: require('../../static/icons/junk-icon.png')
        }
    },
    filter: {
        formatMoney: function (value) {
            return Util.formatMoney(value)
        }
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        getImagesURL: function (prod, prop, size) {
            return Util.getImagesUrl(prod, prop, size)
        },
        isModotap: function () {
            return Util.isTapMode() || (Util.isBalancaMode() && !Util.isHybridMode())
        },
        toggleDetalhes (key) {
            this.$set(this.mostrar, key, !this.mostrar[key])
        },
        calculateQuantity: function (product, comboQuantity, fatherQuantity) {
            return CartController.calculateQuantity(product, comboQuantity, fatherQuantity)
        },
        calculateItemPrice: function (product) {
            return CartController.calculateItemPrice(product)
        },
        calculateItemComboPrice: function (comboItem, fatherQuantity) {
            return CartController.calculateItemComboPrice(comboItem, fatherQuantity)
        },
        calculateObservationPrice: function (observation, comboQuantity, fatherQuantity) {
            return CartController.calculateObservationPrice(observation, comboQuantity, fatherQuantity)
        },
        formatMoney: function (value) {
            return Util.formatMoney(value)
        },
        hasSubgroupDiscount: function (product) {
            return product.totalDiscountSubgroupItem > 0
        },
        getSubtotal: function (product) {
            /* pega o subtotal do itemm sem aplicar o desconto por subgrupo */
            const qty = Number(product.quantity) || 1
            let total = parseFloat(product.totalItemPrice) + parseFloat(product.totalDiscountSubgroupItem || 0)
            return parseFloat(total.toFixed(2) * qty)
        },
        getDiscountTotal: function (product) {
            return parseFloat(product.totalDiscountSubgroupItem || 0) * (product.quantity || 1)
        },
        decreaseQtty: function (key) {
            CartController.decreaseQtty(key, this)
            this.$emit('reloadPrice')
            this.$forceUpdate()
        },
        increaseQtty: function (key) {
            CartController.increaseQtty(key)
            this.$emit('reloadPrice')
            this.$forceUpdate()
        },
        editProduct: function (product, key) {
            this.$router.push({
                name: 'ProductItem',
                params: {product, key, routeBack: 'Checkout'}
            })
        },
        deleteProduct: function (key) {
            CartController.deleteProduct(key, this)
        },
        getProductLanguage: function (product, index) {
            return LocaleController.getIndexLanguages(product, index)
        },
        isAndroidMode: function () {
            return Util.isAndroidMode()
        },
        getProductsComboCombo: function (choosen) {
            let combos = []
            if (choosen) {
                Object.keys(choosen).forEach((e) => {
                    choosen[e].forEach((c) => {
                        combos.push(c)
                    })
                })
            }
            return combos
        },
        getLimits: function (productCode) {
            if (this.unavailableProducts && this.unavailableProducts[productCode]) {
                return this.unavailableProducts[productCode].quantity > this.unavailableProducts[productCode].quantityAvailable
            }
            return false
        },
        noImage: function () {
            return Util.getConfigImage('noImage') || this.junk
        },
        isFosException: function (product, group) {
            let firstLevelComboPrint = group && group.productGroupPrint === 'S'
            let groupPrint = group && group.productGroupPrint === 'S'
            return Util.isFosException(product, this.fatherProdCode, firstLevelComboPrint, groupPrint)
        },
        showChilds: function (group) {
            let firstLevelFatherPrint = group && group.firstLevelFatherPrint
            let childGroupPrint = group && group.productGroupPrint

            if (firstLevelFatherPrint === 'S' && childGroupPrint === 'S') {
                // Se o produto principal do primeiro nível é imprime sim e o grupo promocional do terceiro nivel também é imprime sim, deve exibir o preço dos filhos
                return true
            } else if (firstLevelFatherPrint === 'N') {
                // Se o produto principal do primeiro nível é imprime não, sempre deve exibir o preço dos itens filhos
                return true
            } else {
                return false
            }
        },
        getproductscombo: function (choosen, product) {
            if ((choosen && choosen.subItemCode) === (product && product.subItemCode)) {
                product.observationsChossen = choosen.observations
                product.priceChossen = choosen.price
                return false
            } else {
                return true
            }
        },
        getObservations: function (comboItem, product) {
            if (comboItem && comboItem.observationsChossen) {
                return comboItem.observationsChossen
            } else {
                return comboItem.observations
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>

    @import (reference) url("../assets/common.less");

    .item_card {
        background-color: @white;
        margin-top: 2rem;
        border-radius: 10px;
        box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
        display: grid;
        grid-auto-flow: row;
        grid-template-areas:
        "img info actions"
        "details details details";
        grid-template-columns: 27% auto 20%;
        padding: 1.5rem;
        align-items: center;
        min-height: 200px;
        /*&.n2_columns {
            grid-template-columns: auto 20%;
        }*/

        .card_column_1 {
            grid-area: img;
            width: 100%;
            // height: auto;
            height: inherit;
            align-self: center;
            // margin: auto;
            object-fit: contain;
            max-height: 300px;
        }

        .card_column_2 {
            grid-area: info;
            margin-left: 1.2rem;
            margin-right: 1rem;
            overflow: hidden auto;
            max-height: 400px;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: flex-start;
            span {
                display: block;
                &.product_desc {
                    padding: 20px 0;
                    height: auto;
                    max-height: 45px;
                    overflow: hidden auto;
                }
            }
            .bold_text {
                font-size: 2rem;
                font-weight: bold;
                &.unavaiable {
                    color: red;
                }
            }
            .product_desc {
                font-size: 1.5rem;
                height: auto;
                min-height: 20px;
            }
            .price-section {
                margin-top: 12px;
                width: 100%;
            }

            .price-breakdown {
                display: flex;
                flex-direction: column;
                margin-top: 8px;
                width: 100%;

                .original-price {
                    font-size: 1.4rem;
                    color: #777;
                }

                .discount-amount {
                    font-size: 1.4rem;
                    color: #4caf50;
                    font-weight: bold;
                    margin-top: 2px;
                }

                .final-price {
                    font-size: 2rem;
                    font-weight: bold;
                    color: #222;
                    margin-top: 4px;
                }
            }
        }

        .card_column_3 {
            grid-area: actions;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: flex-end;
            justify-content: center;
            height: 100%;
            .circle_buttons {
                display: flex;
                margin: auto;

                .edit_button {
                    margin-right: 1.5rem;
                }
            }
        }

        .card_column_4 {
            display: flex;
            flex-direction: column;
            grid-area: details;
            align-items: flex-start;
            justify-content: flex-start;
            box-sizing: border-box;
            .details-toggle-btn {
                position: sticky;
                top: 0;
                z-index: 1;
                background-color: @white;
                align-self: flex-start;
                display: flex;
                align-items: center;
                gap: 8px;
                text-align: left;
                width: 100%;
                font-size: 1.5rem;
                font-weight: bold;
                border: none;
                padding: 10px 0;
                cursor: pointer;
                color: inherit;

                &__chevron {
                    flex-shrink: 0;
                    width: 1.5rem;
                    height: 1.5rem;
                    transition: transform 0.35s ease;
                }

                &__chevron.is-open {
                    transform: rotate(180deg);
                }
            }

            .details-expand-enter-active,
            .details-expand-leave-active {
                transition: max-height 0.35s ease-out, opacity 0.3s ease-out, transform 0.35s ease-out;
                overflow: hidden;
                transform-origin: top center;
            }

            .details-expand-enter,
            .details-expand-leave-to {
                max-height: 0;
                opacity: 0;
                transform: scaleY(0);
            }

            .details-expand-enter-to,
            .details-expand-leave {
                max-height: 3000px;
                opacity: 1;
                transform: scaleY(1);
            }

            .details-panel {
                width: 100%;
                .bold_text{
                    font-size: 1.5rem;
                    font-weight: bold;
                    grid-column: 2;
                    &.unavaiable {
                        color: red;
                    }
                }
                .price-col {
                    font-size: 1.5rem;
                    font-weight: bold;
                    grid-column: 2;
                    &.unavaiable {
                        color: red;
                    }
                }

                .detail_quantity {
                    display: flex;
                    justify-content: center;
                    width: 100%;
                    grid-column: 3;
                    font-weight: bold;
                    font-size: 1.5rem;
                }

                .observation-item {
                    width: 100%;
                    display: grid;
                    grid-template-columns: 20% 60% auto;
                    gap: 10px;
                    align-items: center;
                    padding: 20px 0;
                    border-bottom: solid 1px rgba(0, 0, 0, 0.5);
                    &:last-of-type {
                        margin-bottom: 0;
                        border-bottom: none;
                    }
                    .observation-item-content {
                        display: flex;
                        flex-direction: column;
                        gap: 15px;
                    }
                }
                .combo-item {
                    width: 100%;
                    display: grid;
                    grid-template-columns: 20% 60% auto;
                    gap: 10px;
                    align-items: center;
                    padding: 20px 0;
                    width: 100%;
                    border-bottom: solid 1px rgba(0, 0, 0, 0.5);
                    &:last-of-type {
                        margin-bottom: 0;
                        border-bottom: none;
                    }
                    img {
                        align-self: center;
                        margin: auto;
                        object-fit: contain;
                        max-height: 160.27px;
                        max-width: 160.27px;
                        width: 100%;
                    }
                    .combo-item-content {
                        display: flex;
                        flex-direction: column;
                        gap: 15px;
                    }
                    .combo-item-observations {
                        display: contents;
                        width: 100%;
                        align-items: center;
                        padding: 20px 0;
                        grid-column: 2;
                        .combo-item-observation-content {
                            display: flex;
                            flex-direction: column;
                            gap: 15px;
                            grid-column: 2;
                        }
                        .detail_quantity {
                            grid-column: 3;
                        }
                    }
                    .c-combo-options {
                        display: contents;
                        .img{
                            grid-column: 1;
                            align-self: center;
                            margin: auto;
                            -o-object-fit: contain;
                            object-fit: contain;
                            max-height: 160.27px;
                            max-width: 160.27px;
                            width: 100%;
                    }
                    }
                    > img.img:not(:first-of-type) {
                        margin-top: 20px;
                        padding-top: 20px;
                        border-top: solid 1px rgba(0, 0, 0, 0.5);
                    }
                }
            }
        }
    }

    @media (max-width: 698px) { // Gertec SK210
        .item_card {
            // height: 120px;
            margin-top: 10px;
            grid-template-columns: 20% 45% auto !important;
            padding: 10px;
            min-height: 120px;
            &.n2_columns {
                grid-template-columns: auto 25% !important;
            }
            .card_column_1 {
                max-height: 120px;
                // height: inherit;
            }
            .card_column_2 {
                margin-left: 10px;
                width: 100%;
                // max-height: 90px;
                span {
                    &.product_desc {
                        padding: 0;
                        height: 55px;
                    }
                }
                .bold_text,
                .final-price {
                    font-size: 15px;
                    margin:5px 0;
                }
                .product_desc {
                    font-size: 15px;
                }
                .observations {
                    font-size: 12px;
                    span {
                        margin: 0 1px 1px 0;
                        padding: 3px 5px;
                    }
                }

                .price-breakdown {
                    margin-top: 4px;
                    .original-price,
                    .discount-amount {
                        font-size: 15px;
                    }
                    .final-price {
                        font-size: 18px;
                    }
                }
            }
            .card_column_3 {
                .circle_buttons {
                    .edit_button {
                        margin-right: 10px;
                    }
                }
            }
            .card_column_4 {

                .details-toggle-btn {
                    font-size: 15px;
                }
                .details-panel {
                    .observation-item,
                    .combo-item {
                        gap: 5px;
                    }
                    .combo-item {
                        img {
                            align-self: center;
                            margin: auto;
                            max-height: 110px;
                            max-width: 110px;
                        }
                    }
                    .bold_text {
                        font-size: 12px;
                        height: auto;
                        min-height: 15px;
                        max-height: 45px;
                    }

                    .price-col {
                        font-size: 12px;
                        margin: 5px 0;
                    }

                    .detail_quantity {
                        font-size: 12px;
                    }
                }
            }
        }
    }

    @media (min-width: 699px) and (max-width: 1025px) { //@tablet
        .item_card {
            grid-template-columns: 25% auto 20%;
            // max-height: 170px;
            height: auto;
            .card_column_2 {
                overflow: auto;
                // max-height: 150px;
                .bold_text,
                .final-price {
                    font-size: 1.8rem;
                }
                .product_desc {
                    font-size: 1.2rem;
                }
                .observations {
                    font-size: 1.1rem;
                    span {
                        padding: 3px 5px;
                    }
                }
                .price-breakdown {
                    .original-price,
                    .discount-amount {
                        font-size: 1.35rem;
                    }
                    .final-price {
                        font-size: 1.8rem;
                    }
                }
            }
            .card_column_4 {
                .details-panel {
                    .combo-item {
                        img {
                            align-self: center;
                            object-fit: contain;
                            max-height: 110px;
                            max-width: 110px;
                        }
                    }
                    .bold_text {
                        font-size: 1rem;
                        height: auto;
                        min-height: 15px;
                        max-height: 45px;
                    }

                    .price-col {
                        font-size: 1rem;
                        height: auto;
                        min-height: 15px;
                        max-height: 45px;
                    }

                    .detail_quantity {
                        padding: 3px 5px;
                        font-size: 1.1rem;
                    }
                }
            }
        }
    }

    @media (orientation: landscape) {
        .item_card {
            height: auto;
            min-height: 120px;
             // max-height: 150px;
            .card_column_1 {
                max-height: 150px;
                height: inherit;
            }
            .card_column_2 {
                .bold_text,
                .final-price {
                    font-size: 1.5rem;
                }
                span {
                    display: block;
                    &.product_desc {
                        height: auto;
                        min-height: 15px;
                        max-height: 45px;
                    }
                }
                .observations {
                    font-size: 1.1rem;
                }
                .price-breakdown {
                    .original-price,
                    .discount-amount {
                        font-size: 1.2rem;
                    }
                    .final-price {
                        font-size: 1.5rem;
                    }
                }
            }

            .card_column_3 {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;
                margin: 0;
                .circle_buttons {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;
                    margin: 0;
                }
            }
            .card_column_4 {
                .details-toggle-btn {
                    align-self: center;
                }
                .details-panel {
                    .observation-item,
                    .combo-item {
                        margin: 0;
                    }
                    .combo-item {
                        img {
                            align-self: center;
                            height: 120px;
                            width: 120px;
                        }
                    }
                    .bold_text {
                        font-size: 1.2rem;
                    }

                    .price-col {
                        font-size: 1.2rem;
                    }
                }
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/CheckoutItem.vue